import "./progressBar.scss";
import "../../styles/_colors.scss";

import PropTypes from "prop-types";
import React from "react";

import { withContainerContext } from "../container/ContainerContext";

const ProgressBarView = props => {
  let notchClasses = ["progressBarNotch"];
  if (props.animateNotch) {
    notchClasses.push("animated");
  }
  let notchStyle = {
    width: `${props.percent * 100.0}%`
  };

  return (
    <div className="progressBarGuide">
      <div className={notchClasses.join(" ")} style={notchStyle} />
    </div>
  );
};

ProgressBarView.propTypes = {
  percent: PropTypes.number.isRequired,
  animateNotch: PropTypes.bool
};

export default withContainerContext(ProgressBarView);
